import React, { useEffect, useRef, useState } from 'react';
import { ERROR_COLOR } from '..';

type Props = {
  shouldHighlightError: boolean;
  shouldAnimateError: boolean;
};

export default function RequiredLabel({ shouldHighlightError, shouldAnimateError }: Props) {
  const [color, setColor] = useState('#868e96');

  const interval = useRef<number>();
  useEffect(() => {
    if (shouldAnimateError) {
      interval.current = window.setInterval(() => {
        setColor((oldValue) => (oldValue === ERROR_COLOR ? '#868e96' : ERROR_COLOR));
      }, 500);
    } else {
      window.clearInterval(interval.current);
      setColor('#868e96');
    }

    return () => {
      window.clearInterval(interval.current);
    };
  }, [shouldAnimateError]);

  return (
    <div style={{ backgroundColor: shouldHighlightError && !shouldAnimateError ? ERROR_COLOR : color }}>
      <span>Obrigatório</span>
    </div>
  );
}
